{
    "OninboundalertingPara": "U kunt alarmen activeren wanneer inkomende oproepen te lang worden gewaarschuwd.",
    "OntalktimePara": "U kunt ook alarmen activeren wanneer een gesprek een spreektijddrempel bereikt.",
    "OninboundalertingLabel": "Bij inkomende waarschuwingen voorbij:",
    "OntalktimeLabel": "Over gesprekstijd voorbij:",
    "OninboundalertingEnabledHiddenlabel": "Is 'Inbound Alerting Over Setting' ingeschakeld?",
    "OntalktimeEnabledHiddenlabel": "Help weergeven bij alle instellingen van de centrale beheeromgeving.",
    "OninboundalertingPlaceholder": "15s",
    "OntalktimePlaceholder": "5m 0s",
    "CallStateThresholds_SectionHeader": "Drempels voor oproepstatus",
    "NAME": "CallStateThresholds"
}